import { QUESTIONNAIRES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/questionnaires_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
